import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";

// Flag admin `multiespacio` de un venue CUALQUIERA (venues/{id}/adminConfig/
// features). El VenueProvider ya expone `multiespacioActivo`, pero solo del
// venue seleccionado: VenuePage edita el venue de la ruta, que para un admin
// puede ser otro. Ausente ⇒ false (falla cerrado: sin el flag, los espacios
// son solo de exhibición).
export function useMultiespacioFlag(venueId) {
  const [activo, setActivo] = useState(false);

  useEffect(() => {
    if (!venueId) {
      setActivo(false);
      return undefined;
    }
    const unsub = onSnapshot(
      doc(db, "venues", venueId, "adminConfig", "features"),
      (snap) => setActivo(snap.exists() && snap.data()?.multiespacio === true),
      (err) => {
        console.error("Features snapshot error:", err);
        setActivo(false);
      }
    );
    return unsub;
  }, [venueId]);

  return activo;
}
